module.exports = __webpack_public_path__ + "static/media/25487592_1703516036390247_6766579997766989731_o.183ce412.jpg";